import React from 'react';
import { CheckIcon, XIcon } from 'lucide-react';
import { Accent, SectionHeading } from './SectionHeading';
import { beforeList, prepFramework, withList } from '../../data/content';

/** Section 6 — before vs. with, plus the 4-step framework. */
export function SolutionSection() {
  return <section aria-labelledby="solution-heading" className="bg-brand-paper px-5 py-16 lg:px-8 lg:py-24" data-id="element-204" data-mp="1ogxy0d7brfxn">
      <div className="mx-auto max-w-5xl" data-id="element-205" data-mp="1tg0sx4tlc5rw">
        <SectionHeading id="solution-heading" title={<>
              Stop Building Every Brow Class <Accent data-id="element-207" data-mp="1ygf2wser5psk">From Scratch.</Accent>
            </>} data-id="element-206" data-mp="1tf97unxmdqfv" />

        <div className="mt-12 grid gap-5 md:grid-cols-2" data-id="element-208" data-mp="23egih3cyz6za">
          <div className="rounded-[22px] border border-brand-charcoal/10 bg-brand-ivory/70 px-7 py-8 sm:px-9" data-id="element-209" data-mp="27fk1tzu87l59">
            <h3 className="font-body text-[12px] font-bold uppercase tracking-[0.2em] text-brand-charcoal/50" data-id="element-210" data-mp="90pb6ai44z70">
              Before
            </h3>
            <ul className="mt-6 space-y-4" role="list" data-id="element-211" data-mp="d32g4wp1ct2q">
              {beforeList.map(item => <li key={item} className="flex items-start gap-3 text-[15px] leading-snug text-brand-charcoal/60" data-id="element-212" data-mp="o9ksc5lr374">
                  <span className="mt-0.5 flex h-5 w-5 flex-none items-center justify-center rounded-full bg-brand-rose/70" data-id="element-213" data-mp="3n1row6ldxzwx">
                    <XIcon className="h-3 w-3 text-brand-charcoal/70" strokeWidth={2.5} aria-hidden="true" data-id="element-214" data-mp="3i3znmlyup1g2" />
                  </span>
                  {item}
                </li>)}
            </ul>
          </div>

          <div className="rounded-[22px] border border-brand-cta/25 bg-white px-7 py-8 shadow-[0_30px_60px_-40px_rgba(72,103,70,0.55)] sm:px-9" data-id="element-215" data-mp="emraugizcrs7">
            <h3 className="font-body text-[12px] font-bold uppercase tracking-[0.2em] text-brand-cta" data-id="element-216" data-mp="4oabav5z74uj">
              With Brow Instructor Ready™
            </h3>
            <ul className="mt-6 space-y-4" role="list" data-id="element-217" data-mp="2uendnjvp8pcp">
              {withList.map(item => <li key={item} className="flex items-start gap-3 text-[15px] font-medium leading-snug text-brand-charcoal" data-id="element-218" data-mp="2pcy3e6gawfpo">
                  <span className="mt-0.5 flex h-5 w-5 flex-none items-center justify-center rounded-full bg-brand-sage" data-id="element-219" data-mp="1lf482gzq188a">
                    <CheckIcon className="h-3 w-3 text-brand-cta-dark" strokeWidth={2.75} aria-hidden="true" data-id="element-220" data-mp="17iqnv03sysq4" />
                  </span>
                  {item}
                </li>)}
            </ul>
          </div>
        </div>

        <div className="mx-auto mt-12 max-w-3xl rounded-[22px] bg-brand-champagne px-6 py-8 text-center" data-id="element-221" data-mp="12i2zkm6ykpzl">
          <p className="font-body text-[11px] font-semibold uppercase tracking-[0.2em] text-brand-charcoal/55" data-id="element-222" data-mp="oqxuh4ktn5hv">
            How it works
          </p>
          <p className="mt-4 flex flex-wrap items-center justify-center gap-x-3 gap-y-2 font-display text-[1.7rem] font-bold leading-none text-brand-charcoal sm:gap-x-5 sm:text-[2.4rem]" data-id="element-223" data-mp="tn53j68ikx41">
            {prepFramework.map((step, index) => <React.Fragment key={step} data-id="element-224" data-mp="4qgh1tfhyqt" data-mpi={index}>
                {index > 0 && <span aria-hidden="true" className="font-body text-[1.2rem] font-normal text-brand-gold sm:text-[1.5rem]" data-id="element-225" data-mp="3s92f5eaclnd2">
                    →
                  </span>}
                <span className={index === prepFramework.length - 1 ? 'italic text-brand-gold' : ''} data-id="element-226" data-mp="a137tt1i40ie">
                  {step}
                </span>
              </React.Fragment>)}
          </p>
        </div>
      </div>
    </section>;
}